import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { normalizeChannel, getDeviceForChannel } from '../../utils/responsive';
import { triggerAnalyticsEvent } from '../../utils/analytics';
import { trackEvent } from '../../tracking';
import PageSections from '../../pages/PageSections';

export const HubService = () => {
  const { slug } = useParams();
  const { pathname, hash } = useLocation();
  const hasTrackedPageView = useRef(false);

  const isContentfulPreview = pathname.includes('/contentPV/');
  const { channel } = useContext(ExperienceContext);
  const normalizedChannel = normalizeChannel(channel);
  const device = getDeviceForChannel(normalizedChannel);
  const thdCustomer = useThdCustomer();
  const isLoggedIn = thdCustomer?.isLoggedIn ?? null;
  const userID = thdCustomer?.userID ?? null;
  const isB2CCustomer = thdCustomer?.isB2CCustomer ?? null;
  const isB2BCustomer = thdCustomer?.isB2BCustomer ?? null;

  const serviceProps = {
    slug,
    pageName: 'HubService',
    isContentfulPreview,
    hashId: hash?.replace('#', ''),
    device
  };

  const handleAnalyticsEvent = useCallback((eventInput, properties = {}) => {
    const pageContext = {
      page: 'HubService',
      slug,
      timestamp: new Date().toISOString()
    };

    if (eventInput && typeof eventInput === 'object') {
      trackEvent(eventInput, { ...properties, ...pageContext });
      return;
    }

    trackEvent(eventInput, { ...properties, ...pageContext });
  }, [slug]);

  useEffect(() => {
    if (
      !slug
      || hasTrackedPageView.current
    ) {
      return;
    }

    hasTrackedPageView.current = true;
    const customerType = isLoggedIn && isB2BCustomer ? { isB2BCustomer } : { isB2CCustomer: isB2CCustomer ?? true };

    triggerAnalyticsEvent('services-online-express.form-start', {
      serviceSlug: slug,
      pageName: 'HubService',
      leadFormPresent: true,
      thdCustomer: {
        isLoggedIn,
        userID,
        ...customerType
      }
    });
  }, [slug, isLoggedIn, userID, isB2CCustomer, isB2BCustomer]);

  useEffect(() => {
    trackEvent('Page Load', {
      name: 'HubService',
      slug,
      timestamp: new Date().toISOString()
    });
  }, [slug]);

  return (
    <PageSections serviceProps={serviceProps} trackEvent={handleAnalyticsEvent} />
  );
};

export default HubService;
